import React from 'react'
import {
    Show,
    SimpleShowLayout,
    TextField,
    DateField,
    NumberField,
} from 'react-admin'


export const DecretoShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <NumberField source="id" />
            <TextField source="name" />
            <TextField source="description" />
            <TextField source="date" />
        </SimpleShowLayout>
    </Show>
);
